// ABOUTME: Index route for /dashboard — redirects admins to usage and other users to /skills.
import { useAuth } from "@/contexts/AuthContext";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";

interface JWTPayload {
  user_role?: string;
}

function DashboardIndexRedirect() {
  const navigate = useNavigate();
  const { loading, session } = useAuth();

  useEffect(() => {
    if (loading) {
      return;
    }

    const userRole = session?.access_token
      ? jwtDecode<JWTPayload>(session.access_token).user_role
      : null;
    const destination =
      userRole === "admin" || userRole === "superadmin"
        ? "/dashboard/usage"
        : "/skills";

    navigate({ to: destination, replace: true });
  }, [loading, navigate, session]);

  return (
    <div className="flex flex-1 items-center justify-center">
      <p className="text-muted-foreground">Loading dashboard...</p>
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/dashboard/")({
  component: DashboardIndexRedirect,
});
